 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import EBOOK4280 from '@/components/eBook4280'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK42801 from '@/components/eBook42801'
 import EBOOK42802 from '@/components/eBook42802'
 import EBOOK42803 from '@/components/eBook42803'
 import EBOOK42804 from '@/components/eBook42804'
 import EBOOK42805 from '@/components/eBook42805'
 import EBOOK42806 from '@/components/eBook42806'
 import EBOOK42807 from '@/components/eBook42807'
 import EBOOK42808 from '@/components/eBook42808'
 import EBOOK42809 from '@/components/eBook42809'
 import EBOOK428010 from '@/components/eBook428010'
 import EBOOK428011 from '@/components/eBook428011'
 import EBOOK428012 from '@/components/eBook428012'
 import EBOOK428013 from '@/components/eBook428013'
 import EBOOK428014 from '@/components/eBook428014'
 import EBOOK428015 from '@/components/eBook428015'
 import EBOOK428016 from '@/components/eBook428016'
 import EBOOK428017 from '@/components/eBook428017'
 import EBOOK428018 from '@/components/eBook428018'
 import CLEANHANDSPREVIEW from '@/components/CleanHandsPreview'
 import EBOOK428019 from '@/components/eBook428019'
 import EBOOK428020 from '@/components/eBook428020'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/eBook4280",
 			"name" : "eBook4280",
 			"component" : EBOOK4280
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook42801",
 			"name" : "eBook42801",
 			"component" : EBOOK42801
 		},
 		{
 			"path" : "/eBook42802",
 			"name" : "eBook42802",
 			"component" : EBOOK42802
 		},
 		{
 			"path" : "/eBook42803",
 			"name" : "eBook42803",
 			"component" : EBOOK42803
 		},
 		{
 			"path" : "/eBook42804",
 			"name" : "eBook42804",
 			"component" : EBOOK42804
 		},
 		{
 			"path" : "/eBook42805",
 			"name" : "eBook42805",
 			"component" : EBOOK42805
 		},
 		{
 			"path" : "/eBook42806",
 			"name" : "eBook42806",
 			"component" : EBOOK42806
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js